export enum Type {
  ONEDRIVE = 'UserCaptureDatum::Onedrive',
  GOOGLE_DRIVE = 'UserCaptureDatum::GoogleDrive',
  SALESFORCE = 'OrganizationCaptureDatum::Salesforce',
  HUBSPOT = 'OrganizationCaptureDatum::Hubspot',
  FIGMA = 'OrganizationCaptureDatum::Figma',
  GITHUB = 'OrganizationCaptureDatum::Github',
  JIRA = 'OrganizationCaptureDatum::Jira',
  ASANA = 'UserCaptureDatum::Asana',
}

export enum TypeNames {
  GOOGLE_DRIVE_DOCS = 'Google Docs',
  GOOGLE_DRIVE_SHEETS = 'Google Sheets',
  GOOGLE_DRIVE_SLIDES = 'Google Slides',
  SALESFORCE = 'Salesforce',
  HUBSPOT = 'Hubspot',
  FIGMA = 'Figma',
  GITHUB = 'Github',
  JIRA = 'Jira',
  ASANA = 'Asana',
  ONEDRIVE_WORD_DOCUMENT = 'Word Document',
  ONEDRIVE_POWERPOINT_PRESENTATION = 'Powerpoint Presentation',
  ONEDRIVE_EXCEL_SPREADSHEET = 'Excel Spreadsheet',
  ONEDRIVE_FILE = 'OneDrive File',
}

export enum SubType {
  DOCUMENT = 'document',
  SPREADSHEET = 'spreadsheet',
  PRESENTATION = 'presentation',
  WORD_DOCUMENT = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  POWERPOINT_PRESENTATION = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  EXCEL_SPREADSHEET = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export enum InsightType {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  NEW = 'new',
}

export type SurfaceFilters = {
  name?: string;
  typeName?: Array<TypeNames>;
  insight?: Array<InsightType>;
  status?: Array<string>;
  users?: Array<number>;
};
